/**
 * Tracks overlapping async work so only the current generation may publish.
 */
export function createRequestGate() {
  let currentId = 0;

  function start(): number {
    currentId += 1;
    return currentId;
  }

  function isCurrent(requestId: number): boolean {
    return requestId === currentId;
  }

  function abandon(requestId: number): boolean {
    if (!isCurrent(requestId)) {
      return false;
    }

    currentId += 1;
    return true;
  }

  function invalidate(): void {
    currentId += 1;
  }

  return {
    start,
    isCurrent,
    abandon,
    invalidate,
  };
}